import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/**
 * The load carriers one picking round sends along — the boxes and pallets the round's goods travel
 * in, plus whatever empties the order asked for as Leergut, since those are the same pallets.
 *
 * A line is a promise until the round is signed off: `bookedAt` is what says the stock has actually
 * left the yard, and `stockBalance` is what stands there now.
 */
export function useSuborderLoadCarriers(orderId: string, suborderId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["suborder-load-carriers", orderId, suborderId],
		queryFn: async () => {
			const response = await client.stock.orders[":orderId"].suborders[":suborderId"][
				"load-carriers"
			].$get({ param: { orderId, suborderId } });
			const data = await responseHandler(response);
			return data.loadCarriers;
		},
	});

	/** Return */
	return { ...query, loadCarriers: query.data };
}
